import { render, staticRenderFns } from "./UpdateDefaultStatus.vue?vue&type=template&id=60624229"
import script from "./UpdateDefaultStatus.vue?vue&type=script&lang=js"
export * from "./UpdateDefaultStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports